import React from "react";
import { withTranslation } from "react-i18next";
import ObjectUtils from "util/ObjectUtils";
import { Input } from "components/bootstrap";
import { Select, TimeUnitInput } from "components/common";
class DnsAdapterFieldSet extends React.Component {
  constructor() {
    super(...arguments);
    this._onLookupTypeSelect = (id) => {
      const { config, updateConfig } = this.props;
      const newConfig = ObjectUtils.clone(config);
      newConfig.lookup_type = id;
      updateConfig(newConfig);
    };
    this.updateCacheTTLOverride = (value, unit, enabled) => {
      this._updateCacheTTLOverride(value, unit, enabled, "cache_ttl_override");
    };
    this._updateCacheTTLOverride = (value, unit, enabled, fieldPrefix) => {
      const { config, updateConfig } = this.props;
      const newConfig = ObjectUtils.clone(config);
      if (enabled && value) {
        newConfig[fieldPrefix] = enabled && value ? value : null;
        newConfig[`${fieldPrefix}_enabled`] = enabled;
      } else {
        newConfig[fieldPrefix] = null;
        newConfig[`${fieldPrefix}_enabled`] = false;
      }
      newConfig[`${fieldPrefix}_unit`] = enabled ? unit : null;
      updateConfig(newConfig);
    };
  }
  render() {
    const { config, handleFormEvent, validationMessage, validationState, t } = this.props;
    const lookupTypes = [
      { label: t("dns_adapter.lookup_type_a"), value: "A" },
      { label: t("dns_adapter.lookup_type_aaaa"), value: "AAAA" },
      { label: t("dns_adapter.lookup_type_a_aaaa"), value: "A_AAAA" },
      { label: t("dns_adapter.lookup_type_ptr"), value: "PTR" },
      { label: t("dns_adapter.lookup_type_txt"), value: "TXT" }
    ];
    return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
      Input,
      {
        label: t("dns_adapter.lookup_type_label"),
        id: "lookup-type",
        required: true,
        autoFocus: true,
        help: t("dns_adapter.lookup_type_help"),
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      },
      /* @__PURE__ */ React.createElement(
        Select,
        {
          placeholder: t("dns_adapter.lookup_type_placeholder"),
          clearable: false,
          options: lookupTypes,
          onChange: this._onLookupTypeSelect,
          value: config.lookup_type
        }
      )
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "text",
        id: "server_ips",
        name: "server_ips",
        label: t("dns_adapter.server_ips_label"),
        onChange: handleFormEvent,
        help: validationMessage("server_ips", t("dns_adapter.server_ips_help")),
        bsStyle: validationState("server_ips"),
        value: config.server_ips,
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "number",
        id: "request_timeout",
        name: "request_timeout",
        label: t("dns_adapter.request_timeout_label"),
        required: true,
        onChange: handleFormEvent,
        help: validationMessage("request_timeout", t("dns_adapter.request_timeout_help")),
        bsStyle: validationState("request_timeout"),
        value: config.request_timeout,
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      }
    ), /* @__PURE__ */ React.createElement(
      TimeUnitInput,
      {
        label: t("dns_adapter.cache_ttl_override"),
        help: t("dns_adapter.cache_ttl_override_help"),
        update: this.updateCacheTTLOverride,
        value: config.cache_ttl_override,
        unit: config.cache_ttl_override_unit || "MINUTES",
        units: ["MILLISECONDS", "SECONDS", "MINUTES", "HOURS", "DAYS"],
        enabled: config.cache_ttl_override_enabled,
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      }
    ));
  }
}
export default withTranslation("lookup_tables")(DnsAdapterFieldSet);
